import BaseFragmentSerializer from '@square/dashboard-data/serializers/fragment';
export default BaseFragmentSerializer.extend({
  attrs: {
    itemCount: {
      serialize: false
    }
  }
});